import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx";
import fuzzer from "../../utils/fuzzer";
import {StoreContext} from "../../stores/contexts";

class CodeSelector extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      add_field:0,
      search:'',
      filtered_fields:[],
      select_index:-1,
    };
  }
  componentDidMount() {
    this.setState({ filtered_fields: toJS(this.context.configStore.config.data.fields).filter((item)=>{ return item.filter_type; }) });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevState.search !== this.state.search) {
      if(this.state.search) {
        const filteredList = fuzzer(
          {data: this.context.configStore.config.data.fields.filter((item)=>{ return item.filter_type; })},
          this.state.search,
          {
            key: [
              {key: "name", weight: 0.6},
              {key: "code", weight: 0.6}
            ],
            usePathScoring: true,
          }
        );
        this.setState({ filtered_fields: filteredList,select_index:-1 });
      } else {
        this.setState({ filtered_fields: toJS(this.context.configStore.config.data.fields).filter((item)=>{ return item.filter_type; }), select_index:-1 });
      }
    }
  }
  selectItem(item) {
    this.props.onSelect(toJS(item));
    // this.context.configStore.addFieldToLayout(item.code);
    // console.log('select',item);
  }
  isFieldInList() {
    return false;
  }
  renderList() {
    const ret=[];
    this.state.filtered_fields.forEach((item,index)=>{
      ret.push(
        <div onClick={()=>{ if(!this.isFieldInList(item)) { this.selectItem(item); } }} onMouseEnter={()=>{ if(!this.isFieldInList(item)) { this.setState({ select_index:parseInt(index) }) } }} key={index} className={`listItem hpadd10 vpadd5 ${this.state.select_index == index?'bg-pc1 w1':null} ${this.isFieldInList(item)?'op50':''} `}>
          {item.name}
        </div>
      );
    });

    return (
      <div>{ret}</div>
    );

  }
  onKeyUp(e) {
    if(e.which ==  8) {
      if(!this.state.search) {
        e.preventDefault();
        e.stopPropagation();
        if (this.props.onCancel) {
          this.props.onCancel();
        }
      }
    }
    if(e.which == 38 || e.which == 40  || e.which == 13) {
      e.preventDefault();
      e.stopPropagation();
      let needSelect = this.state.select_index;
      let moveTo='';
      switch (e.which) {
        case 38: //up
          moveTo='up';
          needSelect--;
          break;
        case 40: //down
          moveTo='down';
          needSelect++;
          break;
        case 13:
          if(this.state.select_index !== -1) {
            this.selectItem(this.state.filtered_fields[this.state.select_index]);
          }
          break;
      }
      if (needSelect < 0) {
        needSelect = this.state.filtered_fields.length - 1;
      }
      if (needSelect > this.state.filtered_fields.length - 1) {
        needSelect = 0;
      }

      let resetWas=false;
      while(this.isFieldInList(this.state.filtered_fields[needSelect])) {
        if(moveTo === 'down') {
          needSelect++;
        }
        if(moveTo === 'up') {
          needSelect--;
        }
        if (needSelect < 0) {
          if(resetWas) {
            needSelect=-1;
            break;
          }
          needSelect = this.state.filtered_fields.length - 1;
          resetWas=true;
        }
        if (needSelect > this.state.filtered_fields.length - 1) {
          if(resetWas) {
            needSelect = -1;
            break;
          }
          needSelect = 0;
          resetWas=true;
        }
      }

      this.setState({select_index: needSelect});
      if(needSelect!==-1) {
        this.scrollToIfNotVisible(this._scrollReff, this._scrollReff.querySelectorAll('.listItem')[needSelect]);
      }
      // console.log(this._scrollReff.querySelectorAll('.listItem')[needSelect]);

      // console.log('itemRect',itemRect.y-rect.y);
      // this._scrollReff.querySelectorAll('.listItem')[needSelect].scrollIntoView({ block: "nearest" });
    }
  }
  scrollToIfNotVisible(scrollerOb,itemOb) {
    const rect = scrollerOb.getBoundingClientRect();
    const rectScrollTop = scrollerOb.scrollTop;
    const height = scrollerOb.clientHeight;
    const itemRect = itemOb.getBoundingClientRect();
    const diff = itemRect.y - rect.y;
    if(diff<0 || diff+itemOb.clientHeight > scrollerOb.clientHeight) {
      const relPos = diff + rectScrollTop;
      scrollerOb.scrollTop = relPos - (height / 2) + (itemOb.clientHeight/2);
    }
  }
  render() {
    return (
      <div className="bg-w1 shadow" style={{zIndex:20}}>
        <div className="pr z4">
          <div className={`${this.props.relative?"bg-w1 z3 pr":"padd5"}`}>
            <input onKeyDown={(e)=>{ this.onKeyUp(e); }} autoFocus={true} className="w100" type="text" value={this.state.search} onChange={(e)=>{ this.setState({ search:e.target.value }); }}/>
          </div>
          <div className={`ofa ${this.props.relative?"shadow bg-w1":""}`} ref={(ref)=>{ this._scrollReff=ref; }} style={{width:200, maxHeight: 200, ...this.props.relative?{position:"absolute",left:0,top:"100%",width:"100%"}:{} }}>
            {this.renderList()}
          </div>
        </div>
      </div>
    )
  }
}

// export default inject("configStore")(observer(CodeSelector));
export default observer(CodeSelector);